<template>
  <div class="category pl-[10%] pr-[10%] py-2">
    <ul v-if="categoryStore.isCategoryMapEmpty === false"
      class="flex flex-wrap items-center justify-evenly text-gray-900 dark:text-white">
      <li v-for="item in categoryStore.getSubcategoriesByParentId(0)" class="flex flex-col items-center">
        <UPopover mode="hover" :open="open">
          <div class="flex flex-col items-center" @mouseover="setSelectedCategory(item.id ?? -1)">
            <!-- <NuxtImg v-if="categoryStore.shouldDisplayImage" fit="cover" width="42" height="42"
              :src="useImageURL(item.icon ?? '')" :style="{ width: '42px', height: '42px' }"></NuxtImg> -->
            <div class="ml-4 mt-1 flex items-center">
              <p class="text-center text-sm font-medium text-slate-900">
                {{ item.name }}
              </p>
              <UIcon name="i-heroicons:chevron-down-16-solid" class="ml-1" />
            </div>
          </div>
          <template #panel>
            <div>
              <div class="flex" @mouseover="showSecondList" @mouseleave="hideSecondList">
                <ul class="mb-2 mt-2 list-item w-56 text-wrap text-blue-500" v-show="isFirstListVisible">
                  <li v-for="item in categoryStore.getSubcategoriesByParentId(hoveredCategory)" :key="item.icon"
                    class="cursor-pointer px-4 py-2 text-lg hover:bg-slate-100"
                    @mouseover="setSelectedIndex(item.id ?? -1)">
                    <div class="flex items-center justify-between">
                      <p class="text-wrap text-sm text-slate-600 w-full" @click="navigatePage(item.id ?? -1)">
                        {{ item.name }}
                      </p>
                      <Icon name="i-heroicons:chevron-right-20-solid" size="16"></Icon>
                    </div>
                  </li>
                </ul>
                <ul v-show="isSecondListVisible" class="list-item w-56 border-blue-500 pb-2 pt-2 shadow-lg">
                  <li v-for="item in categoryStore.getSubcategoriesByParentId(selectedIndex)"
                    class="cursor-pointer px-4 py-2 text-sm font-medium hover:bg-slate-100">
                    <NuxtLink :to="`/products?`+`product_category_id=${item.id}`+`&page_num=1`">
                      <p class="text-sm text-slate-700 w-full line-clamp-1" @click="navigatePage(item.id ?? -1)">
                        {{ item.name }}
                      </p>
                    </NuxtLink>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </UPopover>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
const categoryStore = useCategoriesStore();
const open = ref(false)
const hoveredCategory = ref(-1)
const isSecondListVisible = ref(false);
const isFirstListVisible = ref(true);
const selectedIndex = ref(0);
const showSecondList = () => {
  isSecondListVisible.value = true;
};

async function navigatePage(id: number) {
  if (id === -1) {
    return
  }
  isFirstListVisible.value = false

  setTimeout(() => {
    isFirstListVisible.value = true
  }, 10)
  hideSecondList()
  // await navigateTo
  //   ({
  //     path: '/products',
  //     query: {
  //       productCategoryId: id,
  //       pageNum: 1
  //     }
  //   })
}
const hideSecondList = () => {
  isSecondListVisible.value = false;
};

function setSelectedCategory(id: number) {
  hoveredCategory.value = id;
}

function setSelectedIndex(index: number) {
  selectedIndex.value = index;
}

</script>
<style scoped>
.category {
  background-color: #fff;
  /* padding: 16px; */
  height: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 0px;
}
</style>
